module.exports = __webpack_public_path__ + "img/star.6a6a3d74.svg";